import { getNumberFormatter, LOCALES } from '../../../../../../../utils/formatting/numberFormatter';

const formatter = getNumberFormatter(LOCALES.EN_US, { maximumFractionDigits: 4 });

export function getCellDataValue(value: string | number) {
    let result = value;
    if (typeof value === 'number') {
        result = formatter.format(value);
    }

    return result;
}
